import mock from 'src/utils/mock';
import { UserInterface as UserInterfaceInterface } from 'src/types/user';
const users: UserInterfaceInterface[] = [
    {
        RegLabID: 9001,
        SubCenterID: 0,
        SubCenterType: 'lLAB',
        UserCode: 'Super993',
        UserProfile: 'Office Admin',
        Empcode: 'Sup901',
        EMAIL: 'ashish@gmail.com',
        CredExpireOn: '2023-10-22T15:17:16.223Z',
        IsExternal: 'False',
        UserDisabled: 'False',
        FailedAttempts: null,
        RecentLogin: null,
        UserLocked: 'True',
        SystemUser: 'False',
        CreatedOn: '2023-09-17T15:17:16.223Z',
    },
    {
        RegLabID: 9001,
        SubCenterID: 0,
        SubCenterType: 'lLAB',
        UserCode: 'Ash123',
        UserProfile: 'Office Admin',
        Empcode: 'Ash123',
        EMAIL: 'ashish@gmail.com',
        CredExpireOn: '2028-12-31T18:30:00.000Z',
        IsExternal: 'True',
        UserDisabled: 'True',
        FailedAttempts: null,
        RecentLogin: null,
        UserLocked: 'True',
        SystemUser: 'False',
        CreatedOn: '2023-09-17T15:37:02.690Z',
    },
];

mock.onGet('/user').reply(() => {
    return [200, { users }];
});

mock.onGet('/user/1').reply((config) => {
    const userData = users.filter((user) => user.RegLabID === parseInt(config.params.id))[0];
    return [200, { data: userData }];
});
